module.exports = __webpack_public_path__ + "static/media/Wht-Logo.3a87a438.png";